import React from "react"

import styles from "./index.module.scss"
import Input from "../../components/Input/Input"
import Button from "../../components/Button/Button"
import ConfirmCancelPopup from "../../components/Popup/ConfirmCancelPopup"
import Loading from "../../components/Loading/Loading"

const AddAdminFormContent = ({
  onCancel,
  closeForm,
  values,
  errors,
  handleSubmit,
  handleChange,
  handleBlur,
  touched,
  isSubmitting,
}) => {
  const [isPopupOpened, setIsPopupOpened] = React.useState(false)

  const handleCancel = () => {
    if (Object.keys(touched).length) {
      setIsPopupOpened(true)
    } else {
      closeForm()
    }
  }

  return (
    <div className={styles.formWrap}>
      {isPopupOpened && (
        <ConfirmCancelPopup
          setIsPopupOpened={setIsPopupOpened}
          handleCancel={() => {
            onCancel ? onCancel() : closeForm()
            setIsPopupOpened(false)
          }}
        />
      )}

      {isSubmitting && (
        <div className={styles.loadingOverlay}>
          <Loading small />
        </div>
      )}

      <form onSubmit={handleSubmit} autoComplete="off">
        <div className={styles.formLabel}>Enter new admin email</div>
        <div className={styles.formItem}>
          <Input
            type="text"
            name="email"
            value={values.email}
            placeholder="Enter new admin email"
            label=""
            autoComplete="off"
            onChange={handleChange}
            onBlur={handleBlur}
            error={errors.email && touched.email}
            errorMessage={errors.email && touched.email && errors.email}
            disabled={isSubmitting}
            fieldStyle="dark"
          />
        </div>

        <div className={styles.formBottom}>
          <div className={styles.formBottomItem}>
            <Button
              type="button"
              onClick={handleCancel}
              buttonStyle="outlined"
              disabled={isSubmitting}
            >
              Cancel
            </Button>
          </div>

          <div className={styles.formBottomItem}>
            <Button type="submit" disabled={isSubmitting}>
              {isSubmitting ? "Saving..." : "Save"}
            </Button>
          </div>
        </div>
      </form>
    </div>
  )
}

export default AddAdminFormContent

